import { Tabs } from 'antd'
import { createContext, useContext, useEffect, useRef, useState } from 'react'
import FullScreenContainer from '../../components/FullScreenContainer/FullScreenContainer'
import '../../styles/antd/collapseStyle.css'
import { useDoctorContext } from './DoctorsView'
import { TabEmptyText } from './DoctorsViewStyle'
import ProfileTab from './DoctorTabs/ProfileTab/ProfileTab'
import QrTab from './DoctorTabs/QrTab/QrTab'

type doctorTabProp = {
  doctorKey: string
  status: string
}

type DoctorTabContextType = {
  activeKey: string
}

const DoctorTabContext = createContext<DoctorTabContextType | undefined>(
  undefined
)

export const useDoctorTabContext = (): DoctorTabContextType => {
  const context = useContext(DoctorTabContext)
  return context!
}

export function DoctorTabs({ doctorKey, status }: doctorTabProp) {
  const { updateViewState } = useDoctorContext()
  const [activeKey, setActiveKey] = useState('1')
  const [scrollHeight, setScrollHeight] = useState(getScrollHeight())
  const tabUseRef = useRef<HTMLDivElement>(null)

  let subTabItems = [
    {
      label: 'Profile',
      title: 'Profile',
      key: '1',
      children: (
        <>
          {' '}
          {status === 'Y' ? (
            <ProfileTab doctorKey={doctorKey} />
          ) : (
            <TabEmptyText>Doctor is Inactive</TabEmptyText>
          )}{' '}
        </>
      ),
    },
    {
      label: 'QR Code',
      title: 'QR Code',
      key: '2',
      children: (
        <>
          {' '}
          {status === 'Y' ? (
            <QrTab doctorKey={doctorKey} />
          ) : (
            <TabEmptyText>Doctor is Inactive</TabEmptyText>
          )}{' '}
        </>
      ),
    },
  ]
  let items = subTabItems.map((subTabItem) => ({
    ...subTabItem,
    children: (
      <FullScreenContainer
        title={subTabItem.title}
        children={subTabItem.children}
      />
    ),
  }))
  useEffect(() => {
    let height = getScrollHeight()
    setScrollHeight(height)
  }, [])
  function getScrollHeight() {
    let element = document.querySelector(`[data-row-key="${doctorKey}"]`)
    return element?.clientHeight ? element.clientHeight + 20 : 0
  }
  useEffect(() => {
    if (updateViewState) setActiveKey('1')
  }, [updateViewState])
  useEffect(() => {
    if (tabUseRef.current) tabUseRef.current.scrollIntoView()
  }, [activeKey])

  return (
    <DoctorTabContext.Provider
      value={{
        activeKey: activeKey,
      }}
    >
      <div style={{ scrollMarginTop: `${scrollHeight}px` }} ref={tabUseRef}>
        <Tabs
          activeKey={activeKey}
          onChange={(activeKey) => {
            setActiveKey(activeKey)
          }}
          type='card'
          defaultActiveKey='1'
          items={items}
        />
      </div>
    </DoctorTabContext.Provider>
  )
}
